// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty_empty__2P9NS {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-transform: uppercase;\n  align-items: center;\n  height: 100%;\n  color: var(--black-30);\n}", ""]);
// Exports
exports.locals = {
	"empty": "empty_empty__2P9NS"
};
module.exports = exports;
